import React from 'react';

// Static data for payment success details
const paymentSuccessDetails = {
  orderConfirmation: "You will receive an email confirmation shortly with the details of your order, including the order number and tracking information.",
  nextSteps: "Your order will be processed and shipped within the next few business days. You can track your order status using the link provided in your confirmation email.",
  supportEmail: "support@siddhicreatives.com",
  returnLink: "/",
  socialLinks: [
    { name: "Facebook", url: "https://facebook.com/siddhicreatives" },
    { name: "Instagram", url: "https://instagram.com/siddhicreatives" },
    { name: "Twitter", url: "https://twitter.com/siddhicreatives" }
  ]
};

const PaymentSuccess = React.memo(() => {
  return (
    <div className="max-w-6xl mx-auto my-10 p-5 bg-white shadow-md rounded-lg mt-20">
      <h1 className="text-3xl font-bold text-center mb-6">Payment Successful</h1>

      <div className="flex flex-col gap-3 py-5 pl-2 sm:pl-6 overflow-hidden">
        <div className="flex flex-col gap-5 items-start w-full">
          <h2 className="text-xl font-bold">Thank You for Your Purchase!</h2>
          <p className="text-gray-700">
            We appreciate your business and are excited to let you know that your payment has been processed successfully. Your order is being prepared and will be shipped shortly.
          </p>

          <h3 className="text-lg font-semibold mt-4">Order Details</h3>
          <p className="text-gray-700">
            {paymentSuccessDetails.orderConfirmation}
          </p>

          <h3 className="text-lg font-semibold mt-4">What Happens Next?</h3>
          <p className="text-gray-700">
            {paymentSuccessDetails.nextSteps}
          </p>

          <h3 className="text-lg font-semibold mt-4">Need Help?</h3>
          <p className="text-gray-700">
            If you have any questions about your order or need assistance, feel free to reach out to our customer service team:
            <br />
            <strong>Email:</strong> <a href={`mailto:${paymentSuccessDetails.supportEmail}`} className="text-blue-500 hover:underline">{paymentSuccessDetails.supportEmail}</a>
          </p>

          <h3 className="text-lg font-semibold mt-4">Stay Connected</h3>
          <p className="text-gray-700">
            Follow us on our social media channels to stay updated on our latest products and promotions!
          </p>
          <div className="flex gap-4 mt-2">
            {paymentSuccessDetails.socialLinks.map((link, index) => (
              <a key={index} href={link.url} className="text-blue-500 hover:underline">{link.name}</a>
            ))}
          </div>

          <div className="mt-5">
            <a href={paymentSuccessDetails.returnLink} className="px-6 py-3 bg-primary-blue uppercase shadow hover:shadow-lg text-white transition duration-300 ease-in-out">
              Continue Shopping
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PaymentSuccess;
